// UnitGroupPermissionDialogPartnerCompanyList - MODULE
// ***********************************************************************************************************************
import { Box, Typography } from "@mui/material";
import * as React from "react";
import { AvatarImage } from "ui/Scripts/source/components/framework/avatarImage";
import { CompanyActiveState, EnumHelper } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { Base } from "../../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/framework/base";
import { CompanyListItem, ICompanyListItem } from "../../../../models/company/companyListItem";
import { CompanyListItems } from "../../../../models/company/companyListItems";
import { SelectCompanyDialog } from "../../../company/SelectCompanyDialog/SelectCompanyDialog";
import { List } from "../../../framework/List/List";
import { ActionContainer } from "../../ActionContainer";
import { FormSectionTitle } from "../../Form/FormSectionTitle";
import { ListIconButtonsItem } from "../../List/ListIconButtons/ListIconButtonsItem/ListIconButtonsItem";

// UnitGroupPermissionDialogPartnerCompanyList
export interface UnitGroupPermissionDialogPartnerCompanyListProp {
    isReadOnly?: boolean;
    availableCompanies: ICompanyListItem[];
    companies: ICompanyListItem[];
    title: string;
    onRemoved: (ids: string[]) => void;
    onAdded: (users: ICompanyListItem[]) => void;
}

interface IUnitGroupPermissionDialogPartnerCompanyListState {
    // List
    isLoading: boolean;
    companies: ICompanyListItem[];
    filter: string;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    selectedId: string;
    checkedIds: string[];

    // Dialog
    showSelectCompanyDialog: boolean;
}

export class UnitGroupPermissionDialogPartnerCompanyList extends React.Component<UnitGroupPermissionDialogPartnerCompanyListProp, IUnitGroupPermissionDialogPartnerCompanyListState> {
    constructor(props: UnitGroupPermissionDialogPartnerCompanyListProp) {
        super(props);
        this.state = {
            isLoading: false,
            companies: props.companies ? props.companies.slice(0) : [],
            filter: "",
            sortColumn: "name",
            sortOrderIsAsc: true,
            selectedId: null,
            checkedIds: [],
            showSelectCompanyDialog: false,
        };
    }

    filteredList = (filter: string, column: string, asc: boolean) => {
        const props = this.props;
        let companies = props.companies ? props.companies.slice(0) : [];
        if (filter) {
            const lowFilter = filter.toLowerCase();
            companies = companies.filter(i => i.code.toLowerCase().indexOf(lowFilter) > -1 || i.name.toLowerCase().indexOf(lowFilter) > -1);
        }
        CompanyListItem.sortCompanyListItems(companies, column, asc);
        this.setState({
            filter,
            sortColumn: column,
            sortOrderIsAsc: asc,
            companies,
        });
    };

    componentDidUpdate(prevProps: UnitGroupPermissionDialogPartnerCompanyListProp, prevState: IUnitGroupPermissionDialogPartnerCompanyListState) {
        const props = this.props;
        const state = this.state;
        if (Base.equalStrArrays(prevProps.availableCompanies ? prevProps.availableCompanies.map(i => i.id) : [], props.availableCompanies ? props.availableCompanies.map(i => i.id) : []) &&
            Base.equalStrArrays(prevProps.companies ? prevProps.companies.map(i => i.id) : [], props ? props.companies.map(i => i.id) : [])) return;
        this.filteredList(state.filter, state.sortColumn, state.sortOrderIsAsc);
    }

    handleSearchLines = (sortColumn: string, sortOrderIsAsc: boolean, nextPage: boolean) => {
        const state = this.state;
        this.filteredList(state.filter, sortColumn, sortOrderIsAsc);
    };

    handleSetSelectedIds = (selectedId: string, checkedIds: string[]) => {
        this.setState({
            selectedId,
            checkedIds
        });
    };

    handleRemove = async () => {
        const props = this.props;
        const state = this.state;
        const selectedIds = List.getSelectedIds(state.selectedId, state.checkedIds);
        if (selectedIds.length < 1) return;
        props.onRemoved(selectedIds);
    };
    
    handleAdd = () => {
        this.setState({
            showSelectCompanyDialog: true
        });
    };

    // #region SelectCompanyDialog
    handleGetCompanyListItems = (pageSize: number, page: number, filter: string, companyGroupIds: string[],
        activityState: number, sortColumn: string, sortOrderIsAsc: boolean,
        ignoreCompanyGroupId: string, ignoreCompanyIds: string[]): Promise<CompanyListItems> => {
        const props = this.props;
        let availableCompanies = (props.availableCompanies ? props.availableCompanies.slice(0) : []).filter(i => ignoreCompanyIds.indexOf(i.id) < 0);
        if (filter) {
            const lowFilter = filter.toLowerCase();
            availableCompanies = availableCompanies.filter(i => i.code.toLowerCase().indexOf(lowFilter) > -1 || i.name.toLowerCase().indexOf(lowFilter) > -1);
        }
        CompanyListItem.sortCompanyListItems(availableCompanies, sortColumn, sortOrderIsAsc);
        const result = new CompanyListItems();
        result.items = availableCompanies;
        return Base.getPromiseResult(result);
    };

    handleSelectCompanyDialogOk = async (companies: ICompanyListItem[]) => {
        const props = this.props;
        if (!companies || companies.length < 1) return;
        this.setState({
            showSelectCompanyDialog: false
        });
        props.onAdded(companies);
    };

    handleSelectCompanyDialogCancel = () => {
        this.setState({
            showSelectCompanyDialog: false
        });
    };
    // #endregion SelectCompanyDialog

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <>
                <ActionContainer
                    margin="0"
                    leftItems={
                        <FormSectionTitle margin="0 0 .5rem 0">{props.title ?? Translations.Partners}</FormSectionTitle>
                    }
                    rightItems={
                        <ListIconButtonsItem
                            addTooltip={Translations.AddPartner}
                            removeTooltip={Translations.RemovePartner}
                            addDisabled={props.isReadOnly}
                            removeDisabled={!state.selectedId && state.checkedIds.length < 1}
                            onAdd={this.handleAdd}
                            onRemove={this.handleRemove}
                        />
                    }
                />
                <List
                    multiSelect={false}
                    intialized={true}
                    isLoading={state.isLoading}
                    hasMore={false}
                    doubleClickDisabled={true}
                    lines={
                        state.companies.map((item) => {
                            return {
                                columns: [
                                    {
                                        classes: "col code",
                                        column: "code",
                                        size: 12,
                                        content:
                                            <Box display="flex" alignItems="center">
                                                <AvatarImage
                                                    name={item.name}
                                                    image={item.logo}
                                                    tooltip={item.name}
                                                />
                                                <Typography sx={{ marginLeft: ".5rem" }}>{item.name}</Typography>
                                            </Box>
                                    }
                                ],
                                id: item.id,
                                classes: EnumHelper.isEqual(item.activeState, CompanyActiveState.NotInUse) ? "disabled" : ""
                            };
                        })}
                    noDataMessage={Translations.AddPartners}
                    sortColumn={state.sortColumn}
                    sortOrderIsAsc={state.sortOrderIsAsc}
                    selectedId={state.selectedId}
                    checkedIds={state.checkedIds}
                    onSetSelectedIds={this.handleSetSelectedIds}
                    onSearchLines={this.handleSearchLines}
                />
                {state.showSelectCompanyDialog &&
                    <SelectCompanyDialog
                        multiSelect={true}
                        ignoreCompanyIds={props.companies.map(i => i.id)}
                        title={Translations.SelectEventPartner}
                        onOk={this.handleSelectCompanyDialogOk}
                        onCancel={this.handleSelectCompanyDialogCancel}
                        onGetCompanyListItems={this.handleGetCompanyListItems}
                    />
                }
            </>
        );
    }
}